// src/components/ProfileAccount.tsx

import { useState } from 'react';
import NoticeComponent from '../../components/NoticeComponent';
import ProfileSidebar from '../../components/ProfileSidebar'; // 오타 수정
import Modal from '../../components/Modal'; // 모달 컴포넌트 임포트
import { HiPencilSquare } from 'react-icons/hi2';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { instance } from "../../api/axiosInstance";

// 계정 세팅 페이지
export default function ProfileAccount() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [passwordVisibility, setPasswordVisibility] = useState({
    oldPassword: false,
    newPassword: false,
    confirmNewPassword: false, // Renamed from 'confirmPassword'
  });

  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });

  const [loading, setLoading] = useState(false); // 로딩 상태
  const [successMessage, setSuccessMessage] = useState(''); // 성공 메시지
  const [errorMessage, setErrorMessage] = useState(''); // 에러 메시지

  const openModal = () => {
    setIsModalOpen(true);
    setPasswordData({
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    });
    setSuccessMessage('');
    setErrorMessage('');
  };
  const closeModal = () => setIsModalOpen(false);

  const togglePasswordVisibility = (
    field: 'oldPassword' | 'newPassword' | 'confirmNewPassword'
  ) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handlePasswordChange = (
    field: 'oldPassword' | 'newPassword' | 'confirmNewPassword',
    value: string
  ) => {
    setPasswordData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const savePassword = async () => {
    // 클라이언트 측 추가 검증 (비밀번호 일치 확인)
    if (passwordData.newPassword !== passwordData.confirmNewPassword) {
      setErrorMessage('새 비밀번호와 확인 비밀번호가 일치하지 않습니다.');
      setSuccessMessage('');
      return;
    }

    // 클라이언트 측 비밀번호 복잡성 검증 (옵션: 필요 시)
    // 여기서는 백엔드에서 검증하므로 클라이언트에서 간단히만 확인
    if (passwordData.newPassword.length < 8) {
      setErrorMessage('비밀번호는 최소 8자 이상이어야 합니다.');
      setSuccessMessage('');
      return;
    }

    setLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      const response = await instance.post('/auth/users/change-password', {
        currentPassword: passwordData.oldPassword,
        newPassword: passwordData.newPassword,
        confirmNewPassword: passwordData.confirmNewPassword,
      });

      setSuccessMessage('비밀번호가 성공적으로 변경되었습니다.');
      setErrorMessage('');
      setPasswordData({
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      });
      setLoading(false);
      setIsModalOpen(false); // 변경 후 모달 닫기 (옵션)
    } catch (error: any) {
      if (error.response && error.response.data) {
        // 백엔드의 에러 메시지 구조에 맞게 수정
        setErrorMessage(error.response.data.message || '비밀번호 변경 중 오류가 발생했습니다.');
      } else {
        setErrorMessage('비밀번호 변경 중 오류가 발생했습니다.');
      }
      setSuccessMessage('');
      setLoading(false);
    }
  };

  const openDeleteModal = () => setIsDeleteModalOpen(true);


  return (
    <section className="max-w-[1440px] w-full h-screen mx-auto mt-[90px]">
      <div className="flex flex-col flex-1 w-full">
      <div className='flex'>
          {/* 사이드바 */}
          <ProfileSidebar /> {/* 오타 수정 */}
          {/* 프로필 콘텐츠 */}
          <article className="h-full w-full">
            <div className="w-full h-full flex flex-row items-start justify-center">
              <div className="max-w-[1440px] w-full h-full px-[80px] pt-[48px] pb-[80px]">
                <div>
                  <NoticeComponent title="계정" content="보안" />
                  <p>
                    보안을 위해 다른 온라인 계정에서는 사용하지 않는 새로운
                    비밀번호를 사용하는 것이 좋습니다.
                  </p>
                </div>
                {/* 비밀번호 설정 */}
                <div className="max-w-[600px] mt-4 flex items-center">
                  <label
                  onClick={openModal}
                    htmlFor="passwordChange"
                    className="text-sm cursor-pointer font-semibold text-MainTextColor mr-2"
                  >
                    비밀번호 변경
                  </label>
                  {/* 아이콘 */}
                  <button
                    
                    className="text-gray-700 hover:opacity-80"
                  >
                    <HiPencilSquare className="text-lg" />
                  </button>
                </div>
                {/* 계정 삭제 버튼 */}

              </div>
            </div>
          </article>
        </div>
      </div>



      {/* 모달 */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        width="500px"
        height="520px"
      >
        <h2 className="text-xl mb-4 font-bold text-MainTextColor tracking-normal">
          비밀번호 수정
        </h2>
        <p className="mb-4 text-sm text-[#1b1b1b]">
          보안을 위해 다른 온라인 계정에서는 사용하지 않는 새로운 비밀번호를
          사용하는 것이 좋습니다.
        </p>

        {/* 성공 메시지 */}
        {successMessage && (
          <div className="mb-4 p-2 bg-green-100 text-green-800 rounded">
            {successMessage}
          </div>
        )}

        {/* 에러 메시지 */}
        {errorMessage && (
          <div className="mb-4 p-2 bg-red-100 text-red-800 rounded">
            {errorMessage}
          </div>
        )}

        <form>
          {/* 현재 비밀번호 */}
          <div className="mb-3 relative">
            <label className="text-[#303030] font-medium mb-2 block">
              현재 비밀번호
            </label>
            <input
              type={passwordVisibility.oldPassword ? 'text' : 'password'}
              name="oldPassword"
              autoComplete="current-password"
              className="w-full px-4 py-4 border placeholder:text-[#c8c8c8c8] text-MainTextColor rounded-lg focus:outline-none"
              value={passwordData.oldPassword}
              onChange={(e) =>
                handlePasswordChange('oldPassword', e.target.value)
              }
              placeholder="현재 비밀번호 입력"
            />
            <button
              type="button"
              className="absolute right-4 top-[65%] transform -translate-y-1/2 text-[#969696c8]"
              onClick={() => togglePasswordVisibility('oldPassword')}
            >
              {passwordVisibility.oldPassword ? (
                <AiOutlineEye size={24} />
              ) : (
                <AiOutlineEyeInvisible size={24} />
              )}
            </button>
          </div>

          {/* 새 비밀번호 */}
          <div className="mb-3 relative">
            <label className="text-[#303030] font-medium mb-2 block">
              새 비밀번호
            </label>
            <input
              type={passwordVisibility.newPassword ? 'text' : 'password'}
              name="newPassword"
              autoComplete="new-password"
              className="w-full px-4 py-4 border placeholder:text-[#c8c8c8c8] text-MainTextColor rounded-lg focus:outline-none"
              value={passwordData.newPassword}
              onChange={(e) =>
                handlePasswordChange('newPassword', e.target.value)
              }
              placeholder="새 비밀번호 입력"
            />
            <button
              type="button"
              className="absolute right-4 top-[65%] transform -translate-y-1/2 text-[#969696c8]"
              onClick={() => togglePasswordVisibility('newPassword')}
            >
              {passwordVisibility.newPassword ? (
                <AiOutlineEye size={24} />
              ) : (
                <AiOutlineEyeInvisible size={24} />
              )}
            </button>
          </div>

          {/* 비밀번호 다시 입력 */}
          <div className="mb-4 relative">
            <label className="text-[#303030] font-medium mb-2 block">
              비밀번호 다시 입력
            </label>
            <input
              type={
                passwordVisibility.confirmNewPassword ? 'text' : 'password'
              }
              name="confirmNewPassword"
              autoComplete="new-password"
              className="w-full px-4 py-4 border placeholder:text-[#c8c8c8c8] text-MainTextColor rounded-lg focus:outline-none"
              value={passwordData.confirmNewPassword}
              onChange={(e) =>
                handlePasswordChange('confirmNewPassword', e.target.value)
              }
              placeholder="비밀번호 다시 입력"
            />
            <button
              type="button"
              className="absolute right-4 top-[65%] transform -translate-y-1/2 text-[#969696c8]"
              onClick={() =>
                togglePasswordVisibility('confirmNewPassword')
              }
            >
              {passwordVisibility.confirmNewPassword ? (
                <AiOutlineEye size={24} />
              ) : (
                <AiOutlineEyeInvisible size={24} />
              )}
            </button>
          </div>

          <button
            type="button"
            className={`w-full py-4 mt-6 bg-black text-white font-bold text-sm rounded-lg hover:bg-opacity-70 transition duration-300 ${loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            onClick={savePassword}
            disabled={loading}
          >
            {loading ? '변경 중...' : '변경사항 저장'}
          </button>
        </form>
      </Modal>
    </section>
  );
}